
import { API } from "./API";

export const AuthenticationAPI = {

  UserLogin: async (userName, password) => {

    let data = JSON.stringify({
      requestValue: {
        userName: userName,
        password: password,
      },
    })

    return await API.post(`Authentication/UserLogin`, data);
  },

  DeleteSession: async (sessionId) => {

    let parameter = JSON.stringify({
      requestValue: {
        sessionId: sessionId,
      },
    })

    return await API.post(`Authentication/DeleteSession`, parameter);
  },

  InsertUserPopupShow: async (userName, insertDate) => {

    let parameter = JSON.stringify({
      requestValue: {
        userName: userName,
        insertDate: insertDate
      },
    })

    return await API.post(`Authentication/InsertUserPopupShow`, parameter);
  },

  IsUserPopupShow: async (userName) => {

    let parameter = JSON.stringify({
      requestValue: {
        userName: userName
      },
    })

    return await API.post(`Authentication/IsUserPopupShow`, parameter);
  },
  
  InsertUILog: async (method, logMessage) => {
   
    let parameter = JSON.stringify({
        requestValue: {
          method : method,
          logMessage : logMessage
        },
      })

    return await API.post(`Authentication/InsertUILog`, parameter);
  },


  RedirectTo2FA: async (isUserGroupAdmin, username, twoFaTransactionId) => {
   
    let parameter = JSON.stringify({
        requestValue: {
          isUserGroupAdmin : isUserGroupAdmin,
          username : username,
          twoFaTransactionId : twoFaTransactionId
        },
      })

    return await API.post(`Authentication/RedirectTo2FA`, parameter);
  },
  
  GetTokenFromTwoFaTransactionId: async (twoFaTransactionId) => {
   
    let parameter = JSON.stringify({
        requestValue: {
          twoFaTransactionId : twoFaTransactionId,         
        },
      })

    return await API.post(`Authentication/GetTokenFromTwoFaTransactionId`, parameter);
  },
};